import { palette } from "lib/miolo";
import { lightFormat, parseISO } from "date-fns";
import type { IBrazilianCompanyIssuerTopLevelFragment } from "lib/fragments/__generated__/BrazilianCompanyIssuerTopLevel.generated";

interface ITotalCompensationsSummaryProps {
  mostRecentRelevantIPE: NonNullable<IBrazilianCompanyIssuerTopLevelFragment["mostRecentRelevantIPE"]>;
}

export default function MostRecentRelevantIpeSummary({ mostRecentRelevantIPE }: ITotalCompensationsSummaryProps) {
  const deliveryDate = parseISO(mostRecentRelevantIPE.deliveryDate);

  return (
    <div
      css={{
        display: "grid",
        gridTemplateColumns: "repeat(3, max-content)",
        alignItems: "center",
        padding: "8px 12px",
        columnGap: 12,
        backgroundColor: palette.catskillWhite,
        borderRadius: 6,
      }}
    >
      {/* Dot */}
      {mostRecentRelevantIPE.category === "Fato Relevante" && (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 12,
              height: 12,
              backgroundColor: palette.mojo,
              borderRadius: 8,
            }}
          />
        </div>
      )}
      {mostRecentRelevantIPE.category === "Aviso aos Acionistas" && mostRecentRelevantIPE.type === "Outros avisos" && (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 12,
              height: 12,
              backgroundColor: palette.dixie,
              borderRadius: 8,
            }}
          />
        </div>
      )}
      {mostRecentRelevantIPE.category === "Dados Econômico-Financeiros" && (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 12,
              height: 12,
              backgroundColor: palette.scienceBlue,
              borderRadius: 8,
            }}
          />
        </div>
      )}
      {mostRecentRelevantIPE.category === "Comunicado ao Mercado" && (
        <div>
          <div
            css={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 12,
              height: 12,
              backgroundColor: palette.amazon,
              borderRadius: 8,
            }}
          />
        </div>
      )}

      <div
        css={{
          fontFamily: "museo-sans-condensed",
          lineHeight: 1.33,
          letterSpacing: 1,
        }}
      >
        <a
          href={mostRecentRelevantIPE.url}
          target="_blank"
          rel="noopener noreferrer"
          css={{
            color: palette.bigStone,
            fontWeight: "bold",
            fontSize: 16,
            textDecoration: "none",
            borderBottom: "solid 1px transparent",
            "&:hover": {
              borderBottom: `solid 1px`,
            },
          }}
        >
          {mostRecentRelevantIPE.category}
        </a>

        <div>
          <span css={{ fontSize: 14, fontWeight: 500, letterSpacing: 1, color: palette.blueBayoux }}>
            Último publicado—{lightFormat(deliveryDate, "dd/MM/yyyy")}
          </span>
        </div>
      </div>

      <a
        href={mostRecentRelevantIPE.url}
        target="_blank"
        rel="noopener noreferrer"
        css={{ display: "flex", backgroundColor: palette.mystic, padding: 8, borderRadius: 6 }}
      >
        <ExternalLinkIcon />
      </a>
    </div>
  );
}

function ExternalLinkIcon() {
  return (
    <svg width={19} height={19} viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
      <g transform="translate(-7 -7)" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g stroke="#000" strokeWidth={2}>
          <path d="M13.276 8h-2.931A2.345 2.345 0 008 10.345v12.31A2.345 2.345 0 0010.345 25h12.31A2.345 2.345 0 0025 22.655v-2.93M25 13V8h-5M25 8l-9 9" />
        </g>
      </g>
    </svg>
  );
}
